import { render, staticRenderFns } from "./headimage.vue?vue&type=template&id=76dc4309&"
import script from "./headimage.vue?vue&type=script&lang=ts&"
export * from "./headimage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports